import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTrending5: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconTrending5"><Path d="M19.2188 10.9688V10.9688C18.0797 9.82966 16.2328 9.82966 15.0937 10.9688L13.2891 12.7734C12.5771 13.4854 11.4229 13.4854 10.7109 12.7734V12.7734C9.99901 12.0615 8.84474 12.0615 8.13281 12.7734L3.75 17.1562M3.75 3.75V17.1562M20.25 20.25H6.75C5.09315 20.25 3.75 18.9069 3.75 17.25V17.1562" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconTrending5;
